export const faqs = [
  {
    q: '爆料网的内容主要来自哪里？',
    a: '内容由编辑团队根据公开社交平台讨论、节目物料与网友投稿线索进行整理。我们会在每条内容中标注已知信息与待核实部分，避免把讨论当作结论。',
  },
  {
    q: '为什么有些爆料只有“疑似”“传闻”字样？',
    a: '娱乐话题往往先有讨论、后有回应。对于缺少官方说明的内容，我们会如实使用“传闻”“疑似”等表述，并提示以官方信息为准，这也是对当事人的基本尊重。',
  },
  {
    q: '站内内容多久更新一次？',
    a: '热点话题基本做到当天更新，日常频道每天早、中、晚三个时段集中补充。页面顶部的“今日已更新”数量会随编辑进度调整。',
  },
  {
    q: '可以用站内的筛选和搜索找旧话题吗？',
    a: '可以。吃瓜精选区域支持按频道标签筛选，也可以用关键词搜索本页已展示的内容。目前筛选与搜索仅作用于当前页面上的条目。',
  },
  {
    q: '如何第一时间收到新爆料提醒？',
    a: '在页面底部的订阅区域留下邮箱即可。订阅仅用于发送爆料盘点，不会用于其他用途，也支持随时退订。',
  },
  {
    q: '如果内容有误或涉及权益问题怎么办？',
    a: '我们提供联系与更正说明渠道。核实后会对相关内容进行更正或下线处理，并保留完整的处理记录，力求信息准确、表达克制。',
  },
];